export enum TransitionState {
	EXITED = 'exited',
	ENTERING = 'entering',
	ENTERED = 'entered',
	EXITING = 'exiting',
}
